import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
import App from './App';
import PublicEntryPage from './components/PublicEntryPage';
import reportWebVitals from './reportWebVitals';

// Wrapper to pass linkToken from URL to App
const SharedNoteRoute = () => {
  const { linkToken } = useParams();
  return <App sharedLinkToken={linkToken} />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/shared/:linkToken" element={<SharedNoteRoute />} />
        <Route path="/comprovante/:slug" element={<PublicEntryPage />} />
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
